import { render, staticRenderFns } from "./SaidaTabList.vue?vue&type=template&id=04a097c5&scoped=true"
import script from "./SaidaTabList.vue?vue&type=script&lang=js"
export * from "./SaidaTabList.vue?vue&type=script&lang=js"
import style0 from "./SaidaTabList.vue?vue&type=style&index=0&id=04a097c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a097c5",
  null
  
)

export default component.exports